export const getUniqueListings = listings =>
  (listings || []).filter(
    (listing, index, allListings) =>
      listing?.id?.uuid &&
      allListings.findIndex(candidate => candidate?.id?.uuid === listing.id.uuid) === index
  );

export const getNewestListingsSliderSettings = listingCount => ({
  dots: false,
  arrows: listingCount > 4,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: { arrows: listingCount > 4, slidesToShow: 4 },
    },
    {
      breakpoint: 991,
      settings: { arrows: listingCount > 3, slidesToShow: 3 },
    },
    {
      breakpoint: 767,
      settings: { arrows: listingCount > 2, slidesToShow: 2.5 },
    },
    {
      breakpoint: 480,
      settings: { arrows: listingCount > 1, slidesToShow: 1.5 },
    },
  ],
});
